/**
 * Team V2 Repository - GraphQL Fragments
 *
 * Reusable field selections for Team queries and mutations.
 * Ensures field parity with backend GraphQL schema.
 *
 * @see deploy/router/schemas/core.graphql - Backend schema
 * @see graphql_gateway/src/team_api/team_model.rs - GqlTeam type
 */

import { gql } from '@apollo/client';

export const TEAM_FIELDS_FRAGMENT = gql`
  fragment TeamFields on Team {
    # Identity (6 fields)
    id
    name
    code
    description
    teamType

    # Append-Only (6 fields)
    parentId
    originalId
    version
    isActive
    changedBy
    changeReason

    # Hierarchy (3 fields)
    parentTeamId
    level
    path

    # Leadership (4 fields)
    teamLeadId
    deputyLeadId
    stakeholderIds
    escalationPath

    # Resources (3 fields)
    budgetAllocated
    quotaLimits {
      maxWorkflows
      maxApiCallsPerDay
      maxStorageGb
      maxMembers
      custom
    }
    costCenter

    # Status/Lifecycle (4 fields)
    active
    effectiveDate
    endDate
    statusReason

    # Audit Trail (5 fields)
    createdAt
    updatedAt
    createdBy
    updatedBy
    auditVersion

    # Metadata (3 fields)
    tags
    customFields
    contacts {
      email
      chatChannel
      wikiUrl
      calendarUrl
      custom
    }
  }
`;
